import { render, staticRenderFns } from "./quickEntityAddWidget.vue?vue&type=template&id=c5596e30&scoped=true"
import script from "./quickEntityAddWidget.vue?vue&type=script&lang=js"
export * from "./quickEntityAddWidget.vue?vue&type=script&lang=js"
import style0 from "./quickEntityAddWidget.vue?vue&type=style&index=0&id=c5596e30&prod&lang=css"
import style1 from "./quickEntityAddWidget.vue?vue&type=style&index=1&id=c5596e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5596e30",
  null
  
)

export default component.exports